export const formatDeviceCodeLabel = (deviceCode) => `DIIOT - ${deviceCode}`;

export const getDeviceName = (device) => {
  if (!device || typeof device !== 'object') return '';
  return (device.DeviceName ?? device.Name ?? device.DeviceAlias ?? '').toString().trim();
};

export const formatDeviceNameWithCode = (deviceName, deviceCode) => {
  const codeLabel = formatDeviceCodeLabel(deviceCode);
  const safeName = (deviceName ?? '').toString().trim();
  return safeName ? `${safeName} (${codeLabel})` : codeLabel;
};

export const findDeviceByCode = (userData, deviceCode) => {
  if (!userData || deviceCode === undefined || deviceCode === null || deviceCode === '') return null;

  const targetCode = Number(deviceCode);
  const entities = userData.Entities || [];

  for (const entity of entities) {
    const localities = entity?.Localities || [];
    for (const locality of localities) {
      const devices = locality?.Devices || [];
      const matchedDevice = devices.find((device) => Number(device?.DeviceCode) === targetCode);
      if (matchedDevice) return matchedDevice;
    }
  }

  return null;
};

export const getDeviceNameWithCodeFromUser = (userData, deviceCode) => {
  const device = findDeviceByCode(userData, deviceCode);
  const deviceName = getDeviceName(device);
  return formatDeviceNameWithCode(deviceName, deviceCode);
};

export const getDeviceDisplayPartsFromUser = (userData, deviceCode) => {
  const device = findDeviceByCode(userData, deviceCode);
  const deviceName = getDeviceName(device) || `Datapoint ${deviceCode}`;
  const deviceCodeLabel = formatDeviceCodeLabel(deviceCode);
  return {
    deviceName,
    deviceCodeLabel,
    fullLabel: formatDeviceNameWithCode(deviceName, deviceCode)
  };
};
